module.exports = __webpack_public_path__ + "img/Card_diamond_Q.656c15f4.svg";